const KEY = "pbo-session-v1";

export const saveSession = (code, participantId, username) => {
  const data = readAll();
  data[code.toUpperCase()] = { participantId, username, savedAt: Date.now() };
  localStorage.setItem(KEY, JSON.stringify(data));
};

export const getSession = (code) => {
  const data = readAll();
  return data[code?.toUpperCase()] || null;
};

export const clearSession = (code) => {
  const data = readAll();
  delete data[code.toUpperCase()];
  localStorage.setItem(KEY, JSON.stringify(data));
};

const readAll = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};
